import React, { Component } from 'react'
import classNames from 'classnames'
import { ArrowLeftIcon } from 'components/Utils/Icons'
import { Text } from 'components/base'

const HEADER_INDENT_MARGIN = 16

export default class OutlineTree extends Component {
  render() {
    if (this.props.headers.length === 0) {
      return 'A doc outline is shown here when a doc contains headers.'
    }

    return (
      <div className="position-relative font-size-large">
        {this.props.headers.map(header => {
          const highlighted = header.id === this.props.activeHeaderId
          const level = header.level

          return (
            <div
              key={header.id}
              style={{
                padding: '9px 0',
                marginLeft: HEADER_INDENT_MARGIN * (level - 1),
              }}
              onClick={() => {
                this.props.onHeaderClick(header.id)
              }}
              className={classNames(
                highlighted ? 'font-weight-bold' : 'font-weight-medium',
                header.level === 1 ? 'shade-05' : 'shade-10',
                'pointer font-size-normal',
                'fs-block data-hj-suppress' /* fs-block & data-hj-suppress hides content for FullStory & Hotjar */
              )}
            >
              {header.text}
            </div>
          )
        })}

        {this.props.activeHeaderId && (
          <Text.Action
            className="padding-vertical-normal"
            onClick={() => this.props.onBackTopTop()}
          >
            Back to top
            <ArrowLeftIcon
              className="margin-left-smaller"
              size="10"
              style={{ transform: 'rotate(90deg)', marginBottom: 2 }}
            />
          </Text.Action>
        )}
      </div>
    )
  }

  onHeaderClick = id => {
    this.props.onHeaderClick(id)
  }
}
